import React from "react";

const FormContext = React.createContext({
  isEditMode: false,
  toggleMode: () => {}
});

export default FormContext;
